import type { GetReviewByStoreIdQuery } from "../../../../__generated__/graphql";
import ResponsiveCDNImage from "../../../../components/common/image/responsive-cdn-image";
import heroGray from "../../../../assets/images/hero_gray.png";
import { HiOutlinePhoto } from "react-icons/hi2";
import Skeleton from "react-loading-skeleton";

type ReviewItem = GetReviewByStoreIdQuery["getReviewByStoreId"][number];

interface ReviewListGridProps {
  reviews: ReviewItem[];
  storeId: number;
  onSelectReview: (review: ReviewItem) => void;
  loadMoreRef: React.RefObject<HTMLDivElement>;
  hasMore: boolean;
  isLoadingMore: boolean;
}

const FEATURED_INDICES = [0, 7, 15];

export function ReviewListGrid({
  reviews,
  storeId,
  onSelectReview,
  loadMoreRef,
  hasMore,
  isLoadingMore,
}: ReviewListGridProps) {
  return (
    <>
      <div className="flex items-center pl-4 pt-4">
        <span className="font-bold">구매후기 {reviews.length || 0}개</span>
      </div>
      <div className="grid grid-cols-3 auto-rows-min px-4 gap-x-2 gap-y-3 mt-4">
        {reviews.map((review, index) => (
          <div
            key={review?.id}
            className={`bg-white cursor-pointer ${
              FEATURED_INDICES.includes(index) ? "col-span-2 row-span-2" : ""
            }`}
            onClick={() => onSelectReview(review)}
          >
            <div
              className={`w-full relative rounded-lg overflow-hidden ${
                FEATURED_INDICES.includes(index)
                  ? "aspect-[2/2]"
                  : "aspect-square"
              }`}
            >
              {review?.reviewImages && review.reviewImages.length > 0 ? (
                <div className="relative w-full h-full">
                  <ResponsiveCDNImage
                    src={review?.reviewImages[0]?.img}
                    alt="리뷰 이미지"
                    className="w-full h-full object-cover"
                    sizeRatio={1}
                  />
                  {review.reviewImages.length > 1 && (
                    <div className="absolute top-2 right-2 bg-black/70 rounded-full p-1.5 z-20">
                      <HiOutlinePhoto className="w-3 h-3 text-white" />
                    </div>
                  )}
                </div>
              ) : (
                <div className="w-full h-full bg-gray-50 flex items-center justify-center">
                  <img
                    src={heroGray}
                    alt="리뷰 이미지"
                    className="w-full h-full object-contain"
                  />
                </div>
              )}
              <div className="absolute top-2 left-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium">
                {new Date(review?.createdAt).toLocaleDateString("ko-KR", {
                  month: "numeric",
                  day: "numeric",
                })}
              </div>
              {(review?.order?.amount || review?.order?.baseAmount) &&
                storeId !== 247 && (
                  <div className="text-white absolute bottom-0 right-2 pl-2 pb-2">
                    <div className="inline-block bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium">
                      {review?.order?.amount || review?.order?.baseAmount}원
                    </div>
                  </div>
                )}
              {review.reviewImages && review.reviewImages.length > 1 && (
                <div className="absolute bottom-2 left-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium flex items-center gap-1">
                  <HiOutlinePhoto className="w-3 h-3" />
                  <span>+{review.reviewImages.length - 1}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {hasMore && (
        <div
          ref={loadMoreRef as React.RefObject<HTMLDivElement>}
          className="w-full py-4 flex justify-center"
        >
          {isLoadingMore && (
            <div className="w-full px-4">
              <div className="grid grid-cols-3 auto-rows-min gap-x-2 gap-y-4">
                {Array.from({ length: 6 }).map((_, skeletonIndex) => (
                  <div
                    key={`skeleton-${skeletonIndex}`}
                    className={`${
                      skeletonIndex === 0 || skeletonIndex === 3
                        ? "col-span-2 row-span-2"
                        : ""
                    }`}
                  >
                    <Skeleton
                      className="w-full rounded-lg"
                      style={{
                        height:
                          skeletonIndex === 0 || skeletonIndex === 3
                            ? "200px"
                            : "150px",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
